import { queryAllType } from '../../api/device'
const device = {
  state: {
    listItem : localStorage.getItem('listItem') ? JSON.parse(localStorage.getItem('listItem')) : {},
    deviceTypeList: localStorage.getItem('deviceTypeList') ? JSON.parse(localStorage.getItem('deviceTypeList')) : [],
    deviceTypeAll: []
  },
  mutations: {
    SET_LIST_ITEM: (state, params) => {
      state.listItem = params
      localStorage.setItem('listItem', JSON.stringify(params))
    },
    SET_DEVICE_TYPE_LIST: (state, params) => {
      state.deviceTypeList = params
      localStorage.setItem('deviceTypeList', JSON.stringify(params))
    },
    SET_DEVICE_TYPE_ALL: (state, params) => {
      state.deviceTypeAll = params
    }
  },
  actions: {
    setDataInfo({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_LIST_ITEM', data)
        resolve()
      })
    },
    setDeviceTypeList({ commit }, data) {
      queryAllType().then((res) => {
        if (res) {
          const { success, data } = res
          if (success && !_.isEmpty(data)) {
            const deviceTypeList = data.map(item => {
              return String(item.typeCode)              
            })
            commit('SET_DEVICE_TYPE_ALL', data)
            commit('SET_DEVICE_TYPE_LIST', deviceTypeList)
          } else {
            commit('SET_DEVICE_TYPE_ALL', [])
            commit('SET_DEVICE_TYPE_LIST', [])
          }
        }
      })
    }
  }
}

export default device
